import { IconsProps } from '@/types/shared'
import React from 'react'

const AnalyticsUpIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M3.4 18L2 16.6L9.4 9.15L13.4 13.15L18.6 8H16V6H22V12H20V9.4L13.4 16L9.4 12L3.4 18Z"
                    fill={props?.color || '#00B69B'}
                />
            </svg>
        </div>
    )
}

export default AnalyticsUpIcons
